import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from '@core/services/data.service';
import { IModuleJournal, IModuleJournalResponse, IModuleNotebookSection } from '../interfaces/imodule-journal';

@Injectable({ providedIn: 'root' })
export class ModuleJournalService {
  private dataService = inject(DataService);

  getNotebookSections(courseId: number): Observable<IModuleNotebookSection[]> {
    return this.dataService.get(`lookup/journal-sections/course/${courseId}`);
  }

  getByModuleId(courseId: number, moduleId: string): Observable<IModuleJournalResponse[]> {
    return this.dataService.get(`Module/journal/course/${courseId}/module/${moduleId}`).pipe(
      map((entries: IModuleJournalResponse[]) =>
        entries.map(e => ({ ...e, dateSubmitted: new Date(e.dateSubmitted) }))
      )
    );
  }

  getByCourseId(courseId: number): Observable<IModuleJournalResponse[]> {
    return this.dataService.get(`Module/journal/course/${courseId}`).pipe(
      map((entries: IModuleJournalResponse[]) =>
        entries.map(e => ({ ...e, dateSubmitted: new Date(e.dateSubmitted) }))
      )
    );
  }

  addJournal(payload: IModuleJournal): Observable<boolean> {
    return this.dataService.post('Module/journal', payload, 'Notebook entry saved.');
  }

  editJournal(payload: IModuleJournal & { id: number }): Observable<boolean> {
    return this.dataService.post('Module/journal/edit', payload, 'Notebook entry updated.');
  }

  deleteJournal(journalId: number): Observable<boolean> {
    return this.dataService.delete(`Module/journal/${journalId}`);
  }

  clearForCourse(courseId: number): Observable<boolean> {
    return this.dataService.delete(`Module/journal/course/${courseId}`);
  }
}
